import React, { useState } from "react";
import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  Heading,
  ModalBody,
  useDisclosure,
} from "@chakra-ui/react";
import i18next from "i18next";
import { LoginForm } from "../navbar/loginMenu/LoginForm";

export const NeedLoginPopup: React.FC = () => {
  const [firstRun, setFirstRun] = useState<boolean>(true);
  const { isOpen, onOpen, onClose } = useDisclosure();

  if (!isOpen && firstRun) {
    onOpen();
    setFirstRun(false);
  }

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      isCentered
      closeOnOverlayClick={false}>
      <ModalOverlay />
      <ModalContent bg="white" maxW={["800px"]}>
        <ModalHeader>
          <Heading>{i18next.t("shared:popups.titleLoginRequired")}</Heading>
        </ModalHeader>
        <ModalBody mb={["80px"]}>
          <LoginForm isInPopup={true} onLogin={onClose} />
        </ModalBody>
      </ModalContent>
    </Modal>
  );
};
